module.exports = __webpack_public_path__ + "img/03.25b50df1.png";